import { stringify } from 'qs'
import { apiService } from '../../../api'
import { DeviceDetails } from '../../types'
import { BillingAgreementResponse, BillingAgreementsResponse } from '../types'

const baseURL = '/portal/consumers/billing-agreements'

export enum OrderBy {
  CREATED_AT = 'createdAt',
}

export interface GetBillingAgreementsQuery {
  offset?: number
  limit?: number
  orderBy?: OrderBy
  ascending?: boolean
}

export const defaultGetBillingAgreementsParams = {
  offset: 0,
  limit: 10,
  orderBy: OrderBy.CREATED_AT,
  ascending: false,
}
interface ChangeBillingAgreementPaymentMethodRequest {
  paymentSourceId?: string
  cardId?: string | number
  bankAccountId?: string
  deviceDetails?: DeviceDetails
}
export interface ChangeBillingAgreementPaymentMethodQuery {
  agreementId: number | string
  body: ChangeBillingAgreementPaymentMethodRequest
}

export const billingAgreementsService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getBillingAgreements: build.query<BillingAgreementsResponse, GetBillingAgreementsQuery>({
      query: (params) => {
        const stringifiedParams = stringify({ ...defaultGetBillingAgreementsParams, ...params })
        return {
          url: `${baseURL}?${stringifiedParams}`,
          method: 'GET',
        }
      },
      providesTags: (result) =>
        result !== undefined && result !== null
          ? [...result.results.map((agreement) => ({ type: 'BillingAgreements' as const, id: agreement.id })), 'BillingAgreements']
          : ['BillingAgreements'],
    }),
    getBillingAgreement: build.query<BillingAgreementResponse, number>({
      query: (id) => ({ url: `${baseURL}/${id}`, method: 'GET' }),
      providesTags: (result) => [{ type: 'BillingAgreements' as const, id: result?.id }],
    }),
    changeBillingAgreementPaymentMethod: build.mutation<void, ChangeBillingAgreementPaymentMethodQuery>({
      query: ({ agreementId, body }) => ({
        url: `${baseURL}/${agreementId}/payment-method`,
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: (result, error, request) => [{ type: 'BillingAgreements', id: request.agreementId }],
    }),
    cancelBillingAgreement: build.mutation<void, number>({
      query: (agreementId) => ({
        url: `${baseURL}/${agreementId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, request) => [{ type: 'BillingAgreements', id: request }],
    }),
  }),
})
